<div class="input-data-container">
    <div class="input-container">

    <label *ngIf="!editFlag" class="input-label rbv-label" (click)="onLabelClick()">{{inputValue ? inputValue : placeholder}}</label>
    
    <input *ngIf="editFlag" #inputText type="text"
        class="input-field-label rbv-field"
        [(ngModel)]="inputValue" 
        [name]="name" 
        [disabled]="disabled"
        [placeholder]="placeholder" 
        (blur)="onBlur()" 
        (focus)="onFocus()" 
        (paste)="onPaste($event)" 
        (keypress)="onKeyPress($event)"
        (ngModelChange)="valueChanged()" 
        (keydown.enter)="accept()"
        (keydown.escape)="clear()"
        autocomplete="off" />
  </div>
</div>
